/** Build variant. The web build (itch.io HTML5 embed) never touches game
 * saves; anything else — dev server or the downloadable desktop build —
 * behaves like a full install with local saves. */
export const IS_WEB = import.meta.env.MODE === 'web';
